import axios from 'axios';
import { beurl } from '@/config';
import Vue from 'vue';
import { router, store } from '@/main';
// 拦截请求
axios.interceptors.request.use(request => {
  const token = window.localStorage.hsJwt;
  token && (request.headers.Authorization = token);
  request.headers['Content-Type'] = 'application/json';
  request.headers['Cache-Control'] = 'public';
  return request;
});

// 拦截响应
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // token错误
          window.localStorage.removeItem('hsJwt');
          store.commit({ type: 'setRole', role: '' });
          store.commit({ type: 'setUserName', userName: '' });
          store.commit({ type: 'setUserId', userId: null });
          Vue.notify({
            group: 'foo',
            text: error.response.data.message,
            type: 'custom-yellow',
            duration: 1500,
          });
          router.push({ path: '/login' });
          break;
        case 410:
        case 404:
          // 有弹窗提示的错误
          Vue.notify({
            group: 'foo',
            text: error.response.data.message,
            type: 'custom-red',
            duration: 1500,
          });
          break;
      }
    }

    return Promise.reject(error.response.data);
  },
);

export function getUserInfo() {
  return axios({
    url: `${beurl}/user/token`,
    method: 'get',
  });
}

export function login(option) {
  return axios({
    url: `${beurl}/user/session`,
    method: 'post',
    data: option,
  });
}

export function registerCompany(option) {
  return axios({
    url: `${beurl}/user/company`,
    method: 'post',
    data: option,
  });
}

export function registerPerson(option) {
  return axios({
    url: `${beurl}/user/person`,
    method: 'post',
    data: option,
  });
}

export function getTaskList(option) {
  return axios({
    url: `${beurl}/task`,
    method: 'get',
    params: option,
  });
}

export function getIndustry() {
  return axios({
    url: `${beurl}/industry`,
    method: 'get',
  });
}

export function getTaskType() {
  return axios({
    url: `${beurl}/task-type`,
    method: 'get',
  });
}

export function addTask(option) {
  return axios({
    url: `${beurl}/task`,
    method: 'post',
    data: option,
  });
}

export function getTaskInfoEdit(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/edit`,
    method: 'get',
  });
}

export function getTaskInfo(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}`,
    method: 'get',
  });
}

export function editTask(option, taskId) {
  return axios({
    url: `${beurl}/task/${taskId}`,
    method: 'put',
    data: option,
  });
}

export function startTask(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/status`,
    method: 'put',
    data: { status: option.status },
  });
}

export function stopTask(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}`,
    method: 'delete',
  });
}

export function getImageList(option, taskId) {
  return axios({
    url: `${beurl}/task/${taskId}/imagelist`,
    method: 'get',
    params: option,
  });
}

export function getClassInfo(taskId) {
  return axios({
    url: `${beurl}/task/${taskId}/classes`,
    method: 'get',
  });
}

export function getApproveTaskClass(taskId) {
  return axios({
    url: `${beurl}/approvetask/${taskId}/classes`,
    method: 'get',
  });
}

export function getImageInfo(option) {
  return axios({
    url: `${beurl}/task/${option.id}/image/${option.imageid}`,
    method: 'get',
  });
}

export function getImage(option) {
  if (option.page !== 'edit') {
    return axios({
      url: `${beurl}/task/${option.taskId}/image/process`,
      method: 'get',
    });
  } else {
    if (option.taskId)
      return axios({
        url: `${beurl}/task/image/${option.imageId}`,
        method: 'get',
        params: { taskId: option.taskId },
      });
    else
      return axios({
        url: `${beurl}/task/image/${option.imageId}`,
        method: 'get',
      });
  }
}

export function addAnno(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/image/${option.imageid}/annotation`,
    method: 'post',
    data: option,
  });
}

export function saveAnno(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/image/${option.imageid}/annotation/${option.annotationId}`,
    method: 'put',
    data: option,
  });
}

export function deleteAnno(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/image/${option.imageid}/annotation/${option.annotationId}`,
    method: 'delete',
  });
}

export function annotatedImage(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/image/${option.imageid}`,
    method: 'put',
  });
}

export function approvedImage(option) {
  let cond = {};
  if (option.approveTaskId)
    cond = {
      url: `${beurl}/approvetask/${option.approveTaskId}/approve/image/${option.imageid}`,
      method: 'put',
    };
  else
    cond = {
      url: `${beurl}/task/${option.taskId}/approve/image/${option.imageid}`,
      method: 'put',
    };
  return axios(cond);
}

export function invalidImage(option) {
  if (option.pageType === 'edit') {
    return axios({
      url: `${beurl}/task/${option.taskId}/admin/image/${option.imageid}`,
      method: 'delete',
    });
  } else if (option.pageType === 'saapprove') {
    return axios({
      url: `${beurl}/approvetask/${option.taskId}/image/${option.imageid}`,
      method: 'delete',
    });
  } else {
    return axios({
      url: `${beurl}/task/${option.taskId}/image/${option.imageid}`,
      method: 'delete',
    });
  }
}

export function getAnnotationResult(taskId) {
  return axios({
    url: `${beurl}/task/${taskId}/result.json`,
    method: 'get',
  });
}

export function downloadResultFile(url) {
  return axios({
    url: url,
    method: 'get',
    responseType: 'blob',
  });
}

export function finishImageAdmin(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/admin/image/${option.imageId}`,
    method: 'put',
  });
}

export function deleteImage(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/image/${option.imageId}`,
    method: 'delete',
  });
}

export function fuzzySearchTaskName(option) {
  return axios({
    url: `${beurl}/task/search/name`,
    method: 'get',
    params: option,
  });
}

export function getTaskListByUser(option) {
  return axios({
    url: `${beurl}/task/search/creator/${option.userId}`,
    method: 'get',
  });
}

export function fuzzySearchUserName(option) {
  return axios({
    url: `${beurl}/user/search/name`,
    method: 'get',
    params: option,
  });
}

export function directlySearch(option) {
  return axios({
    url: `${beurl}/task/direct/search`,
    method: 'get',
    params: option,
  });
}

export function getUserTotalClasses() {
  return axios({
    url: `${beurl}/class/all`,
    method: 'get',
  });
}

export function getUserTotalClassesNew() {
  return axios({
    url: `${beurl}/class/all/new`,
    method: 'get',
  });
}

export function addClass(option, userId) {
  return axios({
    url: `${beurl}/class/user/${userId}`,
    method: 'post',
    data: option,
  });
}

export function relateClass(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/class/${option.classId}`,
    method: 'put',
  });
}

export function unrelateClass(option) {
  return axios({
    url: `${beurl}/task/${option.taskId}/class/${option.classId}`,
    method: 'delete',
  });
}

export function submitTaskClassIds(taskId, options) {
  return axios({
    url: `${beurl}/task/${taskId}/classes`,
    method: 'put',
    data: options,
  });
}

export function getUserList(option) {
  return axios({
    url: `${beurl}/user`,
    method: 'get',
    params: option,
  });
}

export function toggleRole(userId, options) {
  return axios({
    url: `${beurl}/user/${userId}/role`,
    method: 'put',
    data: options,
  });
}

export function toggleStatus(userId, options) {
  return axios({
    url: `${beurl}/user/${userId}/status`,
    method: 'put',
    data: options,
  });
}

export function changeUserName(option, userId) {
  return axios({
    url: `${beurl}/user/${userId}/name`,
    method: 'put',
    data: option,
  });
}

export function getStatistics(option) {
  return axios({
    url: `${beurl}/task/statistic`,
    method: 'get',
    params: option,
  });
}

export function getExamAdmin() {
  return axios({
    url: `${beurl}/exam/list`,
    method: 'get',
  });
}

export function getExamAnno(type) {
  return axios({
    url: `${beurl}/exam/available`,
    method: 'get',
    params: { type },
  });
}

export function startExam(examId) {
  return axios({
    url: `${beurl}/exam/${examId}/start`,
    method: 'post',
  });
}

export function getExamImage(examId) {
  return axios({
    url: `${beurl}/exam/${examId}/image`,
    method: 'get',
  });
}

export function finishExamImage(examId, imageId, option) {
  return axios({
    url: `${beurl}/exam/${examId}/image/${imageId}`,
    method: 'post',
    data: option,
  });
}

export function addExam(option) {
  return axios({
    url: `${beurl}/exam`,
    method: 'post',
    data: option,
  });
}

export function addImageToExam(examId, option) {
  return axios({
    url: `${beurl}/exam/${examId}/image`,
    method: 'put',
    data: option,
  });
}

export function releaseExam(examId, options) {
  return axios({
    url: `${beurl}/exam/${examId}/status`,
    method: 'put',
    data: options,
  });
}

export function deleteExam(examId) {
  return axios({
    url: `${beurl}/exam/${examId}`,
    method: 'delete',
  });
}

export function getExamImageList(examId) {
  return axios({
    url: `${beurl}/exam/${examId}/image/list`,
    method: 'get',
  });
}

export function removeImageFromExam(examId, imageIds) {
  return axios({
    url: `${beurl}/exam/${examId}/image`,
    method: 'delete',
    data: { imageIds },
  });
}

export function getFinishedExamIds() {
  return axios({
    url: `${beurl}/exam/image/finished`,
    method: 'get',
  });
}

export function getExamNames() {
  return axios({
    url: `${beurl}/exam`,
    method: 'get',
  });
}

export function getIncorrectList(option) {
  return axios({
    url: `${beurl}/annotation/incorrect/list`,
    method: 'get',
    params: option,
  });
}

export function appealIncorrect(annoId) {
  return axios({
    url: `${beurl}/annotation/incorrect/${annoId}/appeal`,
    method: 'put',
  });
}

export function appealIncorrectCancel(annoId) {
  return axios({
    url: `${beurl}/annotation/incorrect/${annoId}/appeal/cancel`,
    method: 'put',
  });
}

export function getTaskListForSalary(params) {
  return axios({
    url: `${beurl}/task/salary/list`,
    method: 'get',
    params,
  });
}

export function getStatSalary(taskIds) {
  return axios({
    url: `${beurl}/statistics/salary`,
    method: 'get',
    params: { taskIds: taskIds },
  });
}

export function getStatCat(taskIds) {
  return axios({
    url: `${beurl}/statistics/category`,
    method: 'get',
    params: { taskIds: taskIds },
  });
}

export function getExamInfo(examId) {
  return axios({
    url: `${beurl}/exam/${examId}`,
    method: 'get',
  });
}

export function getRank() {
  return axios({
    url: `${beurl}/statistics/rank`,
    method: 'get',
  });
}

export function getUserExamRecords(params) {
  return axios({
    url: `${beurl}/user/exam`,
    method: 'get',
    params,
  });
}

export function getClassesByTaskList(params) {
  return axios({
    url: `${beurl}/task/classes`,
    method: 'get',
    params,
  });
}

export function getTaskExamImage(taskId) {
  return axios({
    url: `${beurl}/task/${taskId}/exam/image`,
    method: 'get',
  });
}

export function startTaskExam(taskId) {
  return axios({
    url: `${beurl}/task/${taskId}/exam/start`,
    method: 'post',
  });
}

export function getTaskAnnoSalary(params) {
  return axios({
    url: `${beurl}/statistics/task/anno/salary`,
    method: 'get',
    params,
  });
}

export function getImageStatistic(options) {
  return axios({
    url: `${beurl}/statistics/images`,
    method: 'post',
    data: options,
  });
}

export function getTaskListToRepair(params) {
  return axios({
    url: `${beurl}/task/revision/list`,
    method: 'get',
    params,
  });
}

export function getModelTaskImage(seq, params) {
  return axios({
    url: `${beurl}/task/revision/${seq}/image`,
    method: 'get',
    params,
  });
}

export function finishRepairImage(seq, imageId) {
  return axios({
    url: `${beurl}/task/revision/${seq}/image/${imageId}`,
    method: 'put',
  });
}

export function updateModelTask(seq, options) {
  return axios({
    url: `${beurl}/task/revision/${seq}`,
    method: 'put',
    data: options,
  });
}

export function getModelTaskStatistic(seq) {
  return axios({
    url: `${beurl}/statistics/revision/${seq}`,
    method: 'get',
  });
}

export function setImageToApproverTwo(taskId, options) {
  return axios({
    url: `${beurl}/task/${taskId}/image/approval`,
    method: 'post',
    data: options,
  });
}

export function submitTaskImages(taskId, options) {
  return axios({
    url: `${beurl}/task/${taskId}/images`,
    method: 'post',
    data: options,
  });
}

export function changeUserInfo(options) {
  return axios({
    url: `${beurl}/user/info`,
    method: 'post',
    data: options,
  });
}

export function updateUserVisibleExams(userId, visibleExamIds) {
  return axios({
    url: `${beurl}/user/${userId}/visible-exams`,
    method: 'put',
    data: { visibleExamIds },
  });
}

/**
 * 发送手机验证码
 * @param {string} option.mobile - 手机号
 * @param {string} option.type - 验证码类型：register 注册，reset 找回密码
 */
export function sendSmsCode(option) {
  return axios({
    url: `${beurl}/user/sms/code`,
    method: 'post',
    data: option,
  });
}

/**
 * 找回密码（使用验证码）
 * @param {Object} option
 * @param {string} option.mobile - 手机号
 * @param {string} option.password - 新密码
 * @param {string} option.authCode - 验证码
 */
export function resetPassword(option) {
  return axios({
    url: `${beurl}/user/password/reset`,
    method: 'post',
    data: option,
  });
}

export function getMatchTaskList(params) {
  return axios({
    url: `${beurl}/match-task/list`,
    method: 'get',
    params,
  });
}

export function getMatchTaskAnnotateImage(matchTaskId) {
  return axios({
    url: `${beurl}/match-task/annotate/${matchTaskId}`,
    method: 'get',
  });
}

export function addMatchTaskPair(matchTaskId, matchTaskImageId, data) {
  return axios({
    url: `${beurl}/match-task/annotate/${matchTaskId}/${matchTaskImageId}`,
    method: 'post',
    data,
  });
}

export function updateMatchTaskPair(matchTaskId, matchTaskImageId, matchTaskPairId, data) {
  return axios({
    url: `${beurl}/match-task/annotate/${matchTaskId}/${matchTaskImageId}/${matchTaskPairId}`,
    method: 'put',
    data,
  });
}

export function deleteMatchTaskPair(matchTaskId, matchTaskImageId, matchTaskPairId) {
  return axios({
    url: `${beurl}/match-task/annotate/${matchTaskId}/${matchTaskImageId}/${matchTaskPairId}`,
    method: 'delete',
  });
}

export function finishMatchTaskImage(matchTaskId, matchTaskImageId) {
  return axios({
    url: `${beurl}/match-task/finish/${matchTaskId}/${matchTaskImageId}`,
    method: 'put',
  });
}
